<template>
    <div class="row">
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: "StateComponent",
};
</script>

<style scoped>

</style>
